import { axios_ } from '@/tools/axios_';
import { Utils } from '@/tools/utils';

// 兼容海量保的一些api
export const sendSMSCode = async (phone) => {
    const res = await axios_({
        url:'/api/organization/oauth/captcha',
        method: 'get',
        params: {
            phone,
            orgId: Utils.getHlbOrgIdByEnv()
        },
    });
    return res.data;
};
